<template>
  <div class="sidebar-content-view active" :class="'container-' + this._uid">
    <div class="sidebar-content-container white no-padding custom-scrollbar" v-if="!loaderActive && items.length < 1">
      <TheEmptyList :title="'Ingen objekter'" :large="false" :icon="'button-glyph-comment'"/>
    </div>

    <overlay-scrollbars :options="{ className: 'sidebar-content-container white no-padding custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <TheLoader :active="loaderActive"/>

      <div class="item-list">
        <span id="hover-card-object-modal" class="hover-card right">
          <div class="data-grid">
            <div class="grid-x grid-padding-x grid-padding-small">
              <div class="cell border-bottom hover-card-header">
                <span class="thumbnail medium">
                  <img src="/static/img/object.svg" alt="" class="data-hc-img-src">
                </span>
                <span class="hover-card-content">
                  <span class="item-title">
                    <span class="title data-hc-title">-</span>
                    <span class="subtitle data-hc-subtitle">-</span>
                    <span class="subtitle data-hc-count">-</span>
                  </span>
                </span>
              </div>

              <div class="cell large-6 border-bottom data-hc-price-low-container">
                <div class="dl-wrap">
                  <span class="dl dt data-hc-price-low-header">Lav vurdering</span>
                  <span class="dl dd data-hc-price-low">-</span>
                </div>
              </div>

              <div class="cell large-6 border-bottom data-hc-price-high-container">
                <div class="dl-wrap">
                  <span class="dl dt data-hc-price-high-header">Høy vurdering</span>
                  <span class="dl dd data-hc-price-high">-</span>
                </div>
              </div>

              <div class="cell large-6">
                <div class="dl-wrap">
                  <span class="dl dt">Minstepris</span>
                  <span class="dl dd data-hc-price-min">-</span>
                </div>
              </div>

              <div class="cell large-6">
                <div class="dl-wrap">
                  <span class="dl dt">Tilslag</span>
                  <span class="dl dd data-hc-sold">-</span>
                </div>
              </div>
            </div>
          </div>
        </span>
        <ul class="show-thumbnails">
          <li
            :data-hc-title="itemTitle(item)"
            :data-hc-subtitle="item.Objektnr"
            :data-hc-price-low="itemVurderingLow(item)"
            :data-hc-price-high="itemVurderingHigh(item)"
            :data-hc-price-min="itemMinstepris(item)"
            :data-hc-sold="itemTilslag(item)"
            :data-hc-count="item.Antall !== undefined ? item.Antall : '-'"
            :data-hc-img-src="objektThumb(item)"
            data-hc-id="hover-card-object-modal"
            class="hover-card-trigger"
            v-for="item in items"
            v-bind:key="item.Objektid">
            <a href="javascript:;" @click="reloadModalWithObjekt(item)" class="item-link" :class="{'active': item.Objektid === objekt.Objektid}">
              <span class="item-icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object"></use></svg></span>
              <span class="thumbnail small placeholder animation">
                <template v-if="objektThumb(item)">
                  <img :src="objektThumb(item)" />
                </template>
                <template v-else>
                  <span class="placeholder"></span>
                </template>
              </span>
              <span class="item-title">
                <span class="title">{{itemTitle(item) | truncate(40)}}</span>
                <span class="subtitle">{{item.Objektnr}}</span>
              </span>
            </a>
            <span class="button-container has-popover" :class="{'popover-active': actionsPopoverActive.hasOwnProperty(item.Objektid)}" :data-objektid="item.Objektid" @click="toggleActionsPopover(item.Objektid)">
              <a class="item-more-button" href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg></a>
              <span class="popover align-x-right align-y-bottom small">
                <ul>
                  <li><a :href="itemKundeLink(item)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis kunde</span></a></li>
                  <li><a :href="itemKontraktLink(item)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis kontrakt</span></a></li>
                  <li><a :href="itemObjektLink(item)" target="_blank"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-new-window"></use></svg> <span>Nytt vindu</span></a></li>
                </ul>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </overlay-scrollbars>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bus from '@/plugins/event-bus'
import accounting from 'accounting-js'

export default {
  name: 'KundeKontraktObjektSidebar',
  data () {
    return {
      actionsPopoverActive: {}
    }
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  created () {
    var $hcID = null
    var vm = this

    window.jQuery('body').on('mouseenter', '.hover-card-trigger', function () {
      // defining data variables
      $hcID = window.jQuery(this).attr('data-hc-id')
      let $hcTitle = window.jQuery(this).attr('data-hc-title')
      let $hcSubTitle = window.jQuery(this).attr('data-hc-subtitle')
      let $hcCount = window.jQuery(this).attr('data-hc-count')
      let $hcPriceLow = window.jQuery(this).attr('data-hc-price-low')
      let $hcPriceHigh = window.jQuery(this).attr('data-hc-price-high')
      let $hcPriceMin = window.jQuery(this).attr('data-hc-price-min')
      let $hcSold = window.jQuery(this).attr('data-hc-sold')
      let $hcImgSrc = window.jQuery(this).attr('data-hc-img-src') || '/static/img/object.svg'

      // update card with new data
      window.jQuery('#' + $hcID).find('.data-hc-title').html($hcTitle)
      window.jQuery('#' + $hcID).find('.data-hc-subtitle').html($hcSubTitle)
      window.jQuery('#' + $hcID).find('.data-hc-count').html('Antall: ' + $hcCount)

      window.jQuery('#' + $hcID).find('.data-hc-price-low').html($hcPriceLow)
      window.jQuery('#' + $hcID).find('.data-hc-price-high').html($hcPriceHigh)

      window.jQuery('#' + $hcID).find('.data-hc-price-min').html($hcPriceMin)
      window.jQuery('#' + $hcID).find('.data-hc-sold').html($hcSold)
      window.jQuery('#' + $hcID).find('.data-hc-img-src').attr('src', '/static/img/object.svg')
      window.jQuery('#' + $hcID).find('.data-hc-img-src').attr('src', $hcImgSrc)

      // defining offset and position variables
      let $offsetTop = window.jQuery(this).offset().top
      let $offsetHeight = window.jQuery(this).height()
      let $offsetBottom = window.innerHeight - $offsetTop - $offsetHeight
      let $hoverCardHeight = window.jQuery('#' + $hcID).height()
      let $hoverCardWidth = window.jQuery('#' + $hcID).width()

      // show the card if not already activeted
      if (!window.jQuery('#' + $hcID).hasClass('active')) {
        window.jQuery('#' + $hcID).addClass('active')

        window.jQuery(document).bind('mousemove', function (e) {
          // hide the hover card if a contextual popover menu is activated
          if (window.jQuery('.popover-active').length) {
            window.jQuery('#' + $hcID).removeClass('active')
            window.jQuery(document).unbind('mousemove', function (e) {})
          } else {
            // make the card follow the mouse pointer
            // making sure the cards height is not taller than the remaining viewport bottom space
            if ($offsetBottom > $hoverCardHeight) {
              window.jQuery('#' + $hcID + '.hover-card.left').css({
                left: e.pageX + 40,
                top: e.pageY + 30
              })
              window.jQuery('#' + $hcID + '.hover-card.right').css({
                left: e.pageX - $hoverCardWidth * 1.25 - 80,
                top: e.pageY + 30
              })
            } else {
              // offset the card if to close to bottom
              window.jQuery('#' + $hcID + '.hover-card.left').css({
                left: e.pageX + 40,
                top: e.pageY - $hoverCardHeight
              })
              window.jQuery('#' + $hcID + '.hover-card.right').css({
                left: e.pageX - $hoverCardWidth * 1.25 - 80,
                top: e.pageY - $hoverCardHeight
              })
            }
          }
        })
      }
    })

    window.jQuery('body').on('mouseleave', '.hover-card-trigger', function () {
      window.jQuery('#' + $hcID).removeClass('active')
      window.jQuery(document).unbind('mousemove', function (e) {})
      window.jQuery('.has-popover').removeClass('popover-active')
      vm.$set(vm, 'actionsPopoverActive', {})
    })
  },
  mounted () {
    var vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.$set(vm, 'actionsPopoverActive', {})
      }
    })

    // Load kontrakt->objekt - always load on mount
    this.$store.dispatch('kundekontraktobjekt/load', this.kontrakt)
  },
  computed: {
    ...mapGetters('kundekontraktobjekt', [
      'items',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),

    loaderActive: function () {
      return this.loading || this.updating
    }
  },
  methods: {
    toggleActionsPopover: function (Objektid) {
      if (this.actionsPopoverActive.hasOwnProperty(Objektid)) {
        this.$delete(this.actionsPopoverActive, Objektid)
      } else {
        this.$set(this.actionsPopoverActive, Objektid, 1)
      }
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
      // return process.env.VUE_APP_AVANTI_API_URL + '/objekt/photo.json?objektnr=' + item.Objektnr + '&size=thumb'
    },
    objektThumbLoaded: function (item) {
      item.Fototatt = 'T'
    },
    itemTitle: function (item) {
      if (item.subtitle) {
        return item.title + ' / ' + item.subtitle
      }

      return item.title
    },
    itemVurderingLow: function (item) {
      if (item.Vurderingspris2 > 0) {
        return accounting.formatNumber(item.Vurderingspris2, { precision: 0, thousand: ' ' })
      } else if (item.Vurderingspris2 === '0' || item.Vurderingspris2 === 0) {
        return '0'
      }

      return '-'
    },
    itemVurderingHigh: function (item) {
      if (item.Vurderingspris1 > 0) {
        return accounting.formatNumber(item.Vurderingspris1, { precision: 0, thousand: ' ' })
      } else if (item.Vurderingspris1 === '0' || item.Vurderingspris1 === 0) {
        return '0'
      }

      return '-'
    },
    itemMinstepris: function (item) {
      if (item.Minstepris > 0) {
        return accounting.formatNumber(item.Minstepris, { precision: 0, thousand: ' ' })
      } else if (item.Minstepris === '0' || item.Minstepris === 0) {
        return '0'
      }

      return '-'
    },
    itemTilslag: function (item) {
      if (this._.startsWith(item.Auksjon, 'AR')) {
        return 'Usolgt'
      } else if (item.Salgspris > 0) {
        return accounting.formatNumber(item.Salgspris, { precision: 0, thousand: ' ' })
      } else if (item.Salgspris === '0' || item.Salgspris === 0) {
        return '0'
      }

      return '-'
    },
    itemObjektLink: function (item) {
      return '/kunde/' + item.innlevav.Kundenr + '?kontrakt=' + item.Kontraktnr + '&objekt=' + item.Objektid + '&searchResult=true&advanced=false'
    },
    itemKontraktLink: function (item) {
      return '/kunde/' + item.innlevav.Kundenr + '?kontrakt=' + item.Kontraktnr + '&searchResult=true&advanced=false'
    },
    itemKundeLink: function (item) {
      return '/kunde/' + item.innlevav.Kundenr + '?searchResult=true&advanced=false'
    },
    reloadModalWithObjekt: function (item) {
      if (this.isFormDirty('objektform')) {
        this.$helpers.showErrorAlert('', 'Du har gjort endringer på objektet,<br>vennligst lagre før du går videre.', true)
      } else {
        window.jQuery('.hover-card-trigger', window.jQuery('body')).trigger('mouseleave')

        this.$set(this, 'actionsPopoverActive', {})

        bus.$emit('objekt-modal-switch', item)
        // bus.$emit('reload-kunde-kontrakt-objekt-modal', this.kontrakt, item)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektSidebarObjektlist.vue